import React from 'react';
import DayColumn from './DayColumn';
import {OpenedDayAverageColumn, WeekAverageColumn} from './AverageColumn';

export default function WeekColumn({
  reportAnalytics,
  phase,
  week,
  displayedQuestions,
  compact,
  openedDay,
  reportType,
  enablePtoAnalytics,
  isApproveReportsLoading,
  popupPosition,
  getDays,
  openDay,
  openApproveReports,
  renderReportsState,
  setPopupPosition,
  getSequenceNumber,
  getLogGroup,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
  getAvgPerDay,
  closeOpenedDay,
  getAvgCellValue,
  getAvgBackgroundColor,
  getTotalTimeSpend,
  timeConvert,
}) {
  return (
    <div className="week" key={phase.guid + week.numInPhase}>
      {!openedDay && <div className="week-header">
        {week.header}
      </div>}
      <div className="days">
        {getDays(week.days, phase, week, {reportAnalytics}).map(day => (
          <DayColumn
            key={week.numInPhase + day}
            reportAnalytics={reportAnalytics}
            phase={phase}
            week={week}
            day={day}
            displayedQuestions={displayedQuestions}
            compact={compact}
            openedDay={openedDay}
            isApproveReportsLoading={isApproveReportsLoading}
            popupPosition={popupPosition}
            openDay={openDay}
            openApproveReports={openApproveReports}
            renderReportsState={renderReportsState}
            setPopupPosition={setPopupPosition}
            getSequenceNumber={getSequenceNumber}
            getLogGroup={getLogGroup}
            getBackgroundColor={getBackgroundColor}
            getCellColor={getCellColor}
            getCellValue={getCellValue}
            renderCommentPopup={renderCommentPopup}
            timeConvert={timeConvert}
            enablePtoAnalytics={enablePtoAnalytics}
          />
        ))}
        {!!openedDay && !enablePtoAnalytics && (
          <OpenedDayAverageColumn
            reportAnalytics={reportAnalytics}
            displayedQuestions={displayedQuestions}
            openedDay={openedDay}
            getAvgPerDay={getAvgPerDay}
            closeOpenedDay={closeOpenedDay}
          />
        )}
        {!enablePtoAnalytics && (
          <WeekAverageColumn
            reportAnalytics={reportAnalytics}
            phase={phase}
            week={week}
            displayedQuestions={displayedQuestions}
            reportType={reportType}
            getAvgCellValue={getAvgCellValue}
            getAvgBackgroundColor={getAvgBackgroundColor}
            getTotalTimeSpend={getTotalTimeSpend}
            timeConvert={timeConvert}
          />
        )}
      </div>
    </div>
  )
}
